module.exports = __webpack_public_path__ + "r-v3/img/select_arrow.194870a8.svg";